import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  title: {
    marginBottom: 16,
  },
  subtitle: {
    marginBottom: 24,
  },
  sectionLabel: {
    marginBottom: 8,
  },
  checkboxLabel: {
    alignItems: "baseline",
    display: "inline-flex",
    gap: 8,
  },
  checkboxRow: { marginBottom: 16 },
    divider: {
      height: 1,
      backgroundColor: theme.palette.divider,
      margin: "24px 0",
    },
  tooltipIconWrap: {
    display: "inline-flex",
  },
  dateRow: {
    display: "flex",
    gap: 16,
    "@media (max-width: 767px)": {
      flexWrap: "wrap",
      gap: 0,
    },
  },
  actions: {
    marginTop: 16,
  },
}));
